import {
  SET_CURRENT_PATIENT,
  UNSET_CURRENT_PATIENT,
} from '../actions/current-patient-actions.ts';

export default (
  state = {},
  action,
) => {
  const newState = _.cloneDeep(state);

  switch (action.type) {
    case SET_CURRENT_PATIENT:
      newState.id = action.id;

      return newState;

    case UNSET_CURRENT_PATIENT:
      newState.id = null;

      return newState;

    default:
      return newState;
  }
};



// WEBPACK FOOTER //
// ./main/reducers/current-patient-reducer.js